/**
 * Function to calculate the remaining time between the current time and a given start time.
 * @param {string} startTime - The ISO string representing the start time of the event.
 * @returns {{ days: number; hours: number; minutes: number; seconds: number } | null}
 *          Returns an object with the days, hours, minutes, and seconds left until the event,
 *          or null if the event time has passed.
 */
import { DateTime } from 'luxon';

const calculateTimeLeft = (startTime: string) => {
	const now = DateTime.now();
	const eventStartTime = DateTime.fromISO(startTime);
	const diff = eventStartTime.diff(now, ['days', 'hours', 'minutes', 'seconds']);

	if (diff.as('seconds') <= 0) {
		return null;
	}

	return {
		days: diff.days,
		hours: diff.hours,
		minutes: diff.minutes,
		seconds: Math.floor(diff.seconds),
	};
};

export default calculateTimeLeft;
